import { Col, Row } from 'antd';
import styled from 'styled-components';
import { priceToString } from '../../util/utils';
import 'antd/dist/antd.css';
import { useEffect, useState } from 'react';

const StyledDiv = styled.div`
  .align-right {
    text-align: right;
  }

  table,
  td,
  th {
    border: 1px solid black;
    border-collapse: collapse;
  }

  table.my_table {
    page-break-after: always;
    font-size: 10px;
    width: 100%;
  }

  .ant-table-thead > tr > td {
    padding: 1px;
  }

  .ant-table-tbody > tr > td {
    padding: 1px;
  }

  .page-header {
    font-size: 13px;
  }
  .page-header.title-1 {
    text-align: center;
    width: 100%;
  }

  .page-header.title-2 {
    text-align: left;
    width: 100%;
  }
`;

interface TableComponent5Props {
  data: any;
  type: number;
}

function TableComponent5({ data, type }: TableComponent5Props) {
  const [summaryData, setSummaryData] = useState<any>();
  useEffect(() => {
    let sumMaterialCostTotal = 0;
    let sumLaborCostTotal = 0;
    let sumExpenseCostTotal = 0;
    let sumTotal = 0;

    for (let i = 0; i < data.items.length; i++) {
      sumMaterialCostTotal += data.items[i].materialCostTotal;
      sumLaborCostTotal += data.items[i].laborCostTotal;
      sumExpenseCostTotal += data.items[i].expenseTotal;
      sumTotal += data.items[i].total;
    }
    setSummaryData({
      sumMaterialCostTotal,
      sumLaborCostTotal,
      sumExpenseCostTotal,
      sumTotal,
    });
  }, [data]);

  let pageTitle = '';
  if (type === 1) pageTitle = '총집계표';
  else if (type === 2) pageTitle = '집계표';
  else if (type === 3) pageTitle = '내역서';

  const genTableSummary = (data: any) => {
    return (
      <>
        <td>
          <div style={{ textAlign: 'center' }}>[합계]</div>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          <div style={{ textAlign: 'right', padding: '1px' }}>
            {priceToString(data.sumMaterialCostTotal)}
          </div>
        </td>
        <td></td>
        <td>
          <div style={{ textAlign: 'right', padding: '1px' }}>
            {priceToString(data.sumLaborCostTotal)}
          </div>
        </td>
        <td></td>
        <td>
          <div style={{ textAlign: 'right', padding: '1px' }}>
            {priceToString(data.sumExpenseCostTotal)}
          </div>
        </td>
        <td></td>
        <td>
          <div style={{ textAlign: 'right', padding: '1px' }}>
            {priceToString(data.sumTotal)}
          </div>
        </td>
      </>
    );
  };

  const genTableTd = (row: any) => {
    return (
      <>
        <td>
          <div style={{ textAlign: 'left', padding: '1px' }}>{row.code}</div>
        </td>
        <td>
          <div style={{ textAlign: 'left', padding: '1px' }}>{row.name}</div>
        </td>
        <td>
          <div style={{ textAlign: 'left', padding: '1px' }}>
            {type === 3 ? row.standard : ''}
          </div>
        </td>
        <td>
          <div style={{ textAlign: 'center', padding: '1px' }}>
            {type === 3 ? row.unit : '식'}
          </div>
        </td>
        <td>
          {row.editable ? (
            type === 3 ? (
              <div style={{ textAlign: 'right', padding: '1px' }}>
                {priceToString(row.quantity)}
              </div>
            ) : (
              <div style={{ textAlign: 'right', padding: '1px' }}>1</div>
            )
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.materialCost)}
            </div>
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.materialCostTotal)}
            </div>
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.laborCost)}
            </div>
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.laborCostTotal)}
            </div>
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.expense)}
            </div>
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.expenseTotal)}
            </div>
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.totalUnitCost)}
            </div>
          ) : null}
        </td>
        <td>
          {row.editable ? (
            <div style={{ textAlign: 'right', padding: '1px' }}>
              {priceToString(row.total)}
            </div>
          ) : null}
        </td>
      </>
    );
  };
  const genTableTr = (rows: any, summaryData: any) => {
    return rows.map((row: any, index: any, arr: any[]) => {
      if (arr.length - 1 === index) {
        return <tr key={index}>{genTableSummary(summaryData)}</tr>;
      } else {
        return <tr key={index}>{genTableTd(row)}</tr>;
      }
    });
  };

  return (
    <StyledDiv>
      <Row justify="center">
        <Col>
          <div>{pageTitle}</div>
        </Col>
      </Row>
      <Row justify="start">
        <Col>
          <div>공사명: {data.projectName}</div>
        </Col>
      </Row>
      {data && summaryData && (
        <>
          <table className="my_table">
            <thead>
              <tr key="aaa">
                <td rowSpan={2} width="5%" style={{ textAlign: 'center' }}>
                  코드
                </td>
                <td rowSpan={2} width="15%" style={{ textAlign: 'center' }}>
                  품명
                </td>
                <td rowSpan={2} width="8%" style={{ textAlign: 'center' }}>
                  규격
                </td>
                <td rowSpan={2} width="3%" style={{ textAlign: 'center' }}>
                  단위
                </td>
                <td rowSpan={2} width="5%" style={{ textAlign: 'center' }}>
                  수량
                </td>
                <td colSpan={2} width="16%" style={{ textAlign: 'center' }}>
                  재료비
                </td>
                <td colSpan={2} width="16%" style={{ textAlign: 'center' }}>
                  노무비
                </td>
                <td colSpan={2} width="16%" style={{ textAlign: 'center' }}>
                  경비
                </td>
                <td colSpan={2} width="16%" style={{ textAlign: 'center' }}>
                  합계
                </td>
              </tr>
              <tr key="bbb">
                <td width="8%" style={{ textAlign: 'center' }}>
                  단가
                </td>
                <td width="8%" style={{ textAlign: 'center' }}>
                  금액
                </td>
                <td width="8%" style={{ textAlign: 'center' }}>
                  단가
                </td>
                <td width="8%" style={{ textAlign: 'center' }}>
                  금액
                </td>
                <td width="8%" style={{ textAlign: 'center' }}>
                  단가
                </td>
                <td width="8%" style={{ textAlign: 'center' }}>
                  금액
                </td>
                <td width="8%" style={{ textAlign: 'center' }}>
                  단가
                </td>
                <td width="8%" style={{ textAlign: 'center' }}>
                  금액
                </td>
              </tr>
            </thead>
            <tbody>{genTableTr(data.items, summaryData)}</tbody>
          </table>
        </>
      )}
    </StyledDiv>
  );
}

export default TableComponent5;
